module.exports = __webpack_public_path__ + "static/media/037.2cac0484.jpg";